// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__j5SLf","title":"AfterBackImages_title__glU0A","images":"AfterBackImages_images__3OTi5"};